// extracted by mini-css-extract-plugin
export default {"no-scrollbar":"scrollbar_no-scrollbar__vA9xE","no-scrollbar-all":"scrollbar_no-scrollbar-all__hzzue"};